import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {};

// Actions
const SET_ADVANCING = 'journey-stops/SET_ADVANCING';
const SET_NOT_ADVANCING = 'journey-stops/SET_NOT_ADVANCING';

const SET_ETA_ACCURACY_ERROR = 'journey-stops/SET_ETA_ACCURACY_ERROR';
const SET_ETA_DATA = 'journey-stops/SET_ETA_DATA';

const SET_OPENED = 'journey-stops/SET_OPENED';
const SET_NOT_OPENED = 'journey-stops/SET_NOT_OPENED';

const stateById = (state, journeyId) => (obj) => {
  return {
    ...state,
    [journeyId]: {
      ...state[journeyId],
      ...obj,
    },
  };
};

// Reducers
export default createReducer(INIT_STATE, {
  [SET_ADVANCING](state, { journeyId, stopId, stage }) {
    return stateById(
      state,
      journeyId
    )({
      advancing: { stopId, stage },
    });
  },
  [SET_NOT_ADVANCING](state, { journeyId }) {
    return stateById(
      state,
      journeyId
    )({
      advancing: false,
    });
  },
  [SET_ETA_ACCURACY_ERROR](state, { journeyId, error }) {
    return stateById(
      state,
      journeyId
    )({
      accuracyError: error,
    });
  },
  [SET_ETA_DATA](state, { journeyId, data }) {
    return stateById(
      state,
      journeyId
    )({
      ETAData: data,
    });
  },
  [SET_OPENED](state, { journeyId, stopId, stage }) {
    return stateById(
      state,
      journeyId
    )({
      opened: { stopId, stage },
    });
  },
  [SET_NOT_OPENED](state, { journeyId }) {
    return stateById(
      state,
      journeyId
    )({
      opened: false,
    });
  },
});

// Action creators
export const setAdvancing = (journeyId, { stopId, stage }) => ({
  type: SET_ADVANCING,
  payload: {
    journeyId,
    stopId,
    stage,
  },
});

export const setNotAdvancing = (journeyId) => ({
  type: SET_NOT_ADVANCING,
  payload: {
    journeyId,
  },
});

export const setETAAccuracyError = (journeyId, error) => ({
  type: SET_ETA_ACCURACY_ERROR,
  payload: {
    journeyId,
    error,
  },
});

export const setETAData = (journeyId, data) => ({
  type: SET_ETA_DATA,
  payload: {
    journeyId,
    data,
  },
});

export const setOpened = (journeyId, { stopId, stage }) => ({
  type: SET_OPENED,
  payload: {
    journeyId,
    stopId,
    stage,
  },
});

export const setNotOpened = (journeyId) => ({
  type: SET_NOT_OPENED,
  payload: {
    journeyId,
  },
});
